import { CloseOutlined, ExportOutlined } from '@ant-design/icons';
import { t } from 'i18next';
import { useContext, useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import DataViewer from 'src/app/components/DataViewer/DataViewer';
import { MapMarkerController } from 'src/app/components/LeafletMapComponent/controllers/MapMarkerController';
import { OverLappedInterests } from 'src/app/components/LeafletMapComponent/leaflet.config';
import styles from 'src/app/components/LeafletMapComponent/overLappedInterests/OverlappedInterest.module.scss';
import showModal from 'src/app/components/ShowModalComponent/ShowModal';
import { getDateString } from 'src/app/helpers/time.helper';
import { SidebarContext } from 'src/app/layouts/default/LayoutDefault';
import { useAppSelector } from 'src/app/redux/hook';
import { getBlock } from 'src/app/services/surfer-service/surfer.service';

interface Props {
  overLappedInterests: OverLappedInterests;
  mapMarkerController: MapMarkerController | undefined;
}

const DraggableComponent = ({ overLappedInterests, mapMarkerController }: Props) => {
  const { x, y, overlappedArray } = overLappedInterests;
  const { isCollapsed } = useContext(SidebarContext);
  const [position, setPosition] = useState({ x: isCollapsed ? x - 460 : x - 650, y: y - 175 });

  useEffect(() => {
    setPosition({ x: isCollapsed ? overLappedInterests.x - 460 : x - 650, y: overLappedInterests.y - 175 });
  }, [overLappedInterests]);

  const { enterpriseIdentifyClass } = useAppSelector((state) => state.user);

  const overLappedInterestItems = overlappedArray.map((overlapped) => {
    const isPrev = overlapped.id.split('-')[0] === 'sub';
    return (
      <div
        key={overlapped.id}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingInline: '.5rem',
          alignItems: 'center',
          borderTop: '1px solid rgba(0,0,0,0.1)',
        }}
      >
        <div
          onClick={() => {
            if (mapMarkerController) {
              mapMarkerController.tooglePrevMarkersOfSelectedInterest(overlapped.id);
            }
          }}
          style={{ cursor: 'pointer', display: 'flex', gap: '3px', paddingBlock: '.5rem', alignItems: 'center' }}
        >
          {/* <FaMapMarker style={{ fontSize: '25px', background:  }} /> */}
          <img
            style={{ width: '35px', height: '35px', objectFit: 'contain' }}
            // @ts-ignore
            // eslint-disable-next-line no-underscore-dangle
            src={overlapped.marker?._icon?.src || ''}
            alt="marker"
          />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
              <span
                style={{
                  fontSize: '11px',
                  background: isPrev ? 'rgba(108, 40, 217, 0.2)' : 'rgba(194, 65, 12, 0.2)',
                  color: isPrev ? '#6d28d9' : '#c2410c',
                  borderRadius: '20px',
                  padding: '2px 8px',
                }}
              >
                {isPrev ? 'Previous' : 'Current'}
              </span>
              <span style={{ fontSize: '12px' }}>{overlapped.label}</span>
            </div>
            <span style={{ textAlign: 'left', fontSize: '12px', color: 'rgba(0,0,0,0.5)' }}>
              {getDateString(overlapped.time)}
            </span>
          </div>
        </div>
        <ExportOutlined
          onClick={async (e) => {
            e.stopPropagation();
            const { data: blockData } = await getBlock({
              blockID: overlapped.blockID,
              enterpriseId: enterpriseIdentifyClass.id || null,
            });
            showModal({
              title: t('nSearchPage.data'),
              content: <DataViewer blockData={blockData} />,
              hasFooter: false,
              size: 'large',
              backgroundColor: 'var(--header_bg)',
            });
          }}
        />
      </div>
    );
  });

  return (
    <Draggable onDrag={(e, data) => setPosition({ x: data.x, y: data.y })} position={position} bounds="body">
      <div className={styles.overLappedDraggable}>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              paddingBlock: '.5rem',
              paddingInline: '1rem',
            }}
          >
            <span>{overlappedArray.length} Locations at this point</span>
            <CloseOutlined
              onClick={() => {
                if (mapMarkerController) {
                  if (mapMarkerController.setOverLappedMarkersAction) {
                    mapMarkerController.setOverLappedMarkersAction(undefined);
                  }
                }
              }}
            />
          </div>
          {overLappedInterestItems}
        </div>
      </div>
      {/* <div className={styles.overLappedDraggable}>
        <div className="overlapped-unit-search-input-container">
          <div className={styles.OverlappedInterestItems}>{overLappedInterestItems}</div>
        </div>
        <button
          type="button"
          onClick={() => {
            if (mapMarkerController) {
              if (mapMarkerController.setOverLappedMarkersAction) {
                mapMarkerController.setOverLappedMarkersAction(undefined);
              }
            }
          }}
          className={styles.overlappedCloseBtn}
        >
          x
        </button>
      </div> */}
    </Draggable>
  );
};

export default DraggableComponent;
